import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import styles from './ApplicationWriterUpsell.module.scss';

const ApplicationWriterUpsell = ({ user, mobile }) => {
  return (
    <div
      className={`${styles.upsellContainer} ${
        mobile ? styles.upsellMobile : styles.upsellDesktop
      }`}
    >
      {!user && (
        <>
          <p className={styles.upsellTitle}>🌐 One-page Website</p>
          <p>
            Your sleek, professional one-page website to link to your best work.
            14 stunning templates to choose from.
          </p>
          <Button
            href="/freelance/one-page-website"
            className={styles.upsellButton}
            bsStyle="info"
          >
            See the templates
          </Button>
        </>
      )}
      {user && !user.pro && (
        <>
          <p className={styles.upsellHeader}>More on Twine</p>
          <p className={styles.upsellTitle}>🌐 One-page Website</p>
          <p>
            Your sleek, professional one-page website to link to your best work.
            14 stunning templates to choose from.
          </p>
          <Button
            href="/freelance/one-page-website"
            className={styles.upsellButton}
            bsStyle="info"
          >
            See the templates
          </Button>
          <hr className={styles.spacer} />
          <p className={styles.upsellTitle}>✨ AI Writer</p>
          <p>Powered by AI ✨ using your Twine profile:</p>
          <p>✉️ AI Cover Letters</p>
          <p>💬 AI Pitch generator</p>
          <p>💼 AI Proposal writer</p>
          <Button
            href="/freelance/cover-letter-proposal-writing-tool"
            className={styles.upsellButton}
            bsStyle="info"
          >
            Try it out
          </Button>
        </>
      )}
      {user && user.pro && (
        <>
          <p className={styles.upsellHeader}>Included in Pro</p>
          <p className={styles.upsellTitle}>🌐 One-page Website</p>
          <p>
            Your sleek, professional one-page website to link to your best work.
            14 stunning templates to choose from.
          </p>
          <Button
            href="/freelance/one-page-website"
            className={styles.upsellButton}
            bsStyle="info"
          >
            See the templates
          </Button>
          <hr className={styles.spacer} />
          <p className={styles.upsellTitle}>✨ AI Writer</p>
          <p>Save time with our AI application writer:</p>
          <p>✉️ AI Cover Letters</p>
          <p>💬 AI Pitch generator</p>
          <p>💼 AI Proposal writer</p>
          <Button
            href="/freelance/cover-letter-proposal-writing-tool"
            className={styles.upsellButton}
            bsStyle="info"
          >
            Generate your pitch
          </Button>
        </>
      )}
    </div>
  );
};

ApplicationWriterUpsell.propTypes = {
  user: PropTypes.object,
  mobile: PropTypes.bool,
};

ApplicationWriterUpsell.defaultProps = {
  mobile: false,
};

export default ApplicationWriterUpsell;
